import { NoData } from '@components/noData'
import GuyStandingCircle from 'images/guy-standing-circle.svg'
import { t } from '@lingui/core/macro'

export const Reports = () => {
  return (
    <NoData
      svg={<GuyStandingCircle />}
      text={{
        title: t`Explore your data sets within the datasets menu. `,
        subtitle: t`Filter, sort, export, and view additional row properties in one place.`,
        body: {
          helperText: {
            href: '/',
            text: t`Go to Datasets.`,
          },
        },
      }}
    />
  )
}
